import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3/index';
import { getActiveRole } from 'auth/store/roles/selectors';
import { deleteRole } from 'auth/store/roles/actions';
import { closeModal } from 'modal/store/actions';
import Button from 'base/components/Button/index';
import Col from 'base/components/Col/index';
import Row from 'base/components/Row/index';


const DeleteRoleModal = ({
  name, closeModal, role, deleteRole,
}) => (
  <>
    <MainTitle withSpaceBelow>Delete Role</MainTitle>

    <FieldWrapper>
        Do you really want to delete
      <Title3>{role && role.name}</Title3>
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => { closeModal(name); deleteRole(role); }}
        >
            Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
DeleteRoleModal.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteRole: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  role: getActiveRole(state),
});

const mapDispatchToProps = {
  deleteRole,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteRoleModal);
